import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "emptyState", "letterGroup"]

  connect() {
    console.log("Lexique controller connected")
  }

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()
    let hasResults = false

    // Reset all letter groups visibility first
    this.letterGroupTargets.forEach(group => {
      group.classList.remove("hidden")
    })

    this.itemTargets.forEach(item => {
      const term = item.querySelector("dt").textContent.toLowerCase()
      const definition = item.querySelector("dd").textContent.toLowerCase()
      
      if (term.includes(query) || definition.includes(query)) {
        item.classList.remove("hidden")
        hasResults = true
      } else {
        item.classList.add("hidden")
      }
    })

    // Hide empty letter groups
    this.letterGroupTargets.forEach(group => {
      const visibleItems = Array.from(group.querySelectorAll("[data-lexique-target='item']"))
        .filter(item => !item.classList.contains("hidden"))
      
      if (visibleItems.length === 0) {
        group.classList.add("hidden")
      }
    })

    // Show empty state if nothing found
    if (this.hasEmptyStateTarget) {
      if (hasResults) {
        this.emptyStateTarget.classList.add("hidden")
      } else {
        this.emptyStateTarget.classList.remove("hidden")
      }
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.search()
    this.inputTarget.focus()
  }
}
